import { Link } from "gatsby"
import Img from "gatsby-image"
import React from "react"

import { FaSearch } from "../../../../../AppReactIcons"
import { Search_InternalLink } from "../../../../../utils/urls"
import Layout from "../../../../Layout"
import SiteContainer from "../../../../SiteContainer"
import { GreenAppButton } from "../../../../buttons"
import { ArticleTopicCard, ListingCard } from "../../../../cards"
import SEO from "../../../../seo"
import { ContentSeparator } from "../../../Utils/ContentSeparator"
import makeDescription from "../../../Utils/makeDescription"
import QueryLifestyleTopics from "./QueryLifestyleTopics"

const LifestyleTopicsPage = () => {
  return (
    <Layout pageTitle="Lifestyle">
      <SEO title="Lifestyle topics" />
      <QueryLifestyleTopics>
        {(heroImage, topics, articles) => (
          <>
            <Img
              fluid={heroImage.childImageSharp.fluid}
              style={{ maxHeight: "256px" }}
            />
            <SiteContainer className="py-8 text-site-blue-dark">
              <section>
                <Link to={Search_InternalLink}>
                  <GreenAppButton
                    title="Search all articles"
                    Icon={<FaSearch />}
                  />
                </Link>
                <ContentSeparator />
                <h1 className="text-site-blue-dark text-3xl  md:text-4xl lg:text-5xl">
                  Manage your lifestyle
                </h1>
                <ContentSeparator />
                <p>
                  We know that living with PCOS posts some challenges to living
                  a healthy life. Women with PCOS may be more likely to gain
                  weight. An unhealthy lifestyle has more impact on weight gain
                  and health for women with PCOS than women without PCOS. We
                  have some suggestion to live the healthiest possible lifestyle
                  to manage PCOS for you:
                </p>
                <br />
                <ul className="list-disc list-inside">
                  <li>
                    Improve diet and physical activity for physical and mental
                    health
                  </li>
                  <li>Prevent weight gain (really important goal)</li>
                  <li>
                    Modest weight loss (if deemed relevant by women and
                    clinicians)
                  </li>
                </ul>
              </section>
              <ContentSeparator />
              <ContentSeparator />

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/*
                  Show article list instead of topic list due to business requirement
                */}
                {/* {topics.map((item: any, index: number) => {
                  // if (topics.length > 6) {
                  //   return (
                  //     <ArticleTopicCard
                  //       slugPrefix={"ask/topics"}
                  //       key={index}
                  //       {...item}
                  //     />
                  //   )
                  // }
                  return (
                    <ListingCard
                      key={index}
                      title={item.title}
                      image={item.image}
                      description={makeDescription(item.description)}
                      link={`/ask/lifestyle/${item.slug}`}
                    />
                  )
                })} */}

                {articles.map((item: any, index: number) => {
                  return (
                    <ListingCard
                      key={index}
                      title={item.title}
                      image={item.image}
                      description={makeDescription(item.description)}
                      link={`/ask/lifestyle/articles/${item.slug}`}
                    />
                  )
                })}
              </div>
              <ContentSeparator />
            </SiteContainer>
          </>
        )}
      </QueryLifestyleTopics>
    </Layout>
  )
}

export default LifestyleTopicsPage
